import { UserGuardGuard } from './shared/guards/user-guard.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: localStorage.getItem('alarm_mode') === 'advanced' ? 'advancedhome' : 'home',
    pathMatch: 'full'
  },
  {
  path: 'home',
  loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
  canActivate: [UserGuardGuard]
}, {
  path: 'login',
  loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
}, {
  path: 'dispatch',
  loadChildren: () => import('./modules/dispatcher/dispatcher.module').then(m => m.DispatcherModule),
  canActivate: [UserGuardGuard]
}, {
  path: 'advancedhome',
  loadChildren: () => import('./modules/advancedhome/advancedhome.module').then(m => m.AdvancedhomeModule),
  canActivate: [UserGuardGuard]
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
